import { type FC } from 'react';
import { type ReactNode } from 'react';
import {
    type ColorlessIconProps,
    HStack,
    IconBulletLevel1,
    IconBulletLevel2,
    IconBulletLevel3,
} from '@direct-frontend/components';

type SelectItemWithLevelProps = { id: string; title: ReactNode; level: number };

const iconListMap: Record<number, FC<ColorlessIconProps>> = {
    1: IconBulletLevel1,
    2: IconBulletLevel2,
    3: IconBulletLevel3,
};

export const SelectItemWithLevel: FC<SelectItemWithLevelProps> = ({ id, title, level }) => {
    const Icon = level > 0 ? (iconListMap[level] ?? iconListMap[3]) : undefined;

    return (
        <HStack gap="8">
            {Array.from({ length: level }).map((_, index) => (
                <div key={`${id}.${index}`} />
            ))}
            {Icon ? <Icon size="24" role="main" /> : null}
            {title}
        </HStack>
    );
};
